import { useEffect, useRef, useState } from "react";

export default function BuildProgressBar({
  buildCreationTimestamp,
  estimatedBuildDurationInSeconds,
}: {
  buildCreationTimestamp: string | undefined;
  estimatedBuildDurationInSeconds: number;
}) {
  const [currentTime, setCurrentTime] = useState(new Date().getTime());
  const isInitialMount = useRef(true);

  const creationTime = buildCreationTimestamp
    ? new Date(buildCreationTimestamp).getTime()
    : null;
  const timePassedInSeconds = creationTime
    ? Math.floor((currentTime - creationTime) / 1000)
    : 0;
  const progress = Math.min(
    (timePassedInSeconds / estimatedBuildDurationInSeconds) * 100,
    95
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().getTime());
    }, 1000);

    // Mark that initial mount is complete after first render
    isInitialMount.current = false;

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center gap-2 w-full max-w-[250px]">
      <div
        className="h-[20px] w-full bg-transparent
      rounded-full border border-white dark:border-[#373B40]"
      >
        <div
          className="w-full h-full overflow-hidden
        rounded-full border-[2px] border-transparent"
        >
          <div
            style={{ transform: `translateX(-${100 - progress}%)` }}
            className={`h-full w-full bg-primary-blue rounded-full ${
              isInitialMount.current ? "" : "transition-transform duration-300"
            }`}
          ></div>
        </div>
      </div>
    </div>
  );
}
